<template>
  <div>
    <custom-filters
      class="d-flex justify-space-around"
      namespace="sensors/errors"
      i18n-path="sensors"
      style="height: 96px; overflow-y: auto"
    />
    <v-data-table
      v-if="frontSort"
      dense
      hide-default-footer
      fixed-header
      calculate-widths
      :items-per-page="data.length"
      :headers="headers"
      v-bind="$attrs"
      :items="data"
      :loading="loading"
      :height="height - 96 + 'px'"
      class="elevation-1 secondarybackground striped-table"
    >
      <template v-slot:top>
        <div class="d-flex justify-space-between">
          <div class="primary--text font-weight-bold ml-10 my-1">
            Alertes Sondes
          </div>
          <v-checkbox
            dense
            label="Tri sur la page"
            v-model="frontSort"
            class="my-1 mr-10"
          ></v-checkbox>
          <custom-page-selector class="pa-2" namespace="sensors/errors" />
        </div>
      </template>
      <template v-slot:item.label="{ item }">
        <truncate-text-with-hover
          v-if="item.label"
          :text="item.label"
          :length="25"
        />
        <div>
          {{ item.error_datetime.toLocaleDateString() }}
        </div>
      </template>
    </v-data-table>
    <v-data-table
      v-else
      dense
      hide-default-footer
      fixed-header
      calculate-widths
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDESC"
      :headers="headers"
      :server-items-length="data.length"
      v-bind="$attrs"
      :items="data"
      :loading="loading"
      :height="height - 96 + 'px'"
      class="elevation-1 secondarybackground striped-table"
    >
      <template v-slot:top>
        <div class="d-flex justify-space-between">
          <div class="primary--text font-weight-bold ml-10 my-1">
            Alertes Sondes
          </div>
          <v-checkbox
            dense
            label="Tri sur la page"
            v-model="frontSort"
            class="my-1 mr-10"
          ></v-checkbox>
          <custom-page-selector class="pa-2" namespace="sensors/errors" />
        </div>
      </template>
      <template v-slot:item.label="{ item }">
        <truncate-text-with-hover
          v-if="item.label"
          :text="item.label"
          :length="25"
        />
        <div>
          {{ item.error_datetime.toLocaleDateString() }}
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CustomPageSelector from '@/components/selects/customPageSelector/index';
import sortable from '@/business/mixins/sortable';
import CustomFilters from '@/components/tools/CustomFilters';
import TruncateTextWithHover from '@/components/tools/TruncateTextWithHover';

export default {
  name: 'SensorsErrorsTable',
  mixins: [sortable],
  components: { CustomFilters, CustomPageSelector, TruncateTextWithHover },
  props: {
    height: Number,
  },
  data: () => ({
    headers: [
      { text: 'Libelle sonde - Date', value: 'label' },
      { text: 'Type', value: 'type' },
      { text: 'Propriété', value: 'meter_property_name' },
      { text: 'Anomalie', value: 'error_label' },
      { text: 'Valeur', value: 'value' },
    ].map((item) => {
      return { ...item, class: 'secondarybackground' };
    }),
    namespace: 'sensors/errors',
    frontSort: false,
    label: 'Alertes Sondes',
  }),
  computed: {
    ...mapGetters({
      data: 'sensors/errors/items',
      loading: 'sensors/errors/isLoadingItems',
    }),
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/table.scss';
</style>
